import React from "react";
import Container from "../components/common/Container";
import SectionHeader from "../components/common/SectionHeader";
import Button from "../components/common/Button";
import { Mail, Phone, MapPin } from "lucide-react";

const Contact = () => {
  return (
    <>
      {/* Header */}
      <section className="bg-slate-50 py-24">
        <Container>
          <center>
          <SectionHeader
            eyebrow="Contact Us"
            title="Let’s talk about your project"
            subtitle="Have an idea or need a reliable development partner? We’d love to hear from you."
          />
          </center>
        </Container>
      </section>

      {/* Contact Content */}
      <section className="py-24 bg-white">
        <Container>
          <div className="grid gap-16 lg:grid-cols-2">
            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-semibold text-slate-900">
                Get in touch
              </h3>

              <p className="mt-4 text-slate-600 leading-relaxed">
                Reach out to us via email or phone, or send us a message using the
                contact form. Our team will get back to you shortly.
              </p>

              <ul className="mt-8 space-y-4 text-sm text-slate-700">
                <li className="flex items-center gap-3">
                  <Mail className="text-blue-600" size={18} />
                  <a href="mailto:support@thebrightlyllc.com">support@thebrightlyllc.com</a>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="text-blue-600" size={18} />
                  <a href="tel:+18333888796">+1 833-388-8796</a>
                </li>
                <li className="flex items-center gap-3">
                  <MapPin className="text-blue-600" size={18} />
                  12740 Parnell Ave Baton Rouge, LA 70815
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Contact;
